// extracted by mini-css-extract-plugin
export default {"title":"style_title__4Uiur","menulist":"style_menulist__-r-4y","come":"style_come__xF-Jt"};